import React, { Component } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import { Link, NavLink, withRouter } from 'react-router-dom';
import { fetchNavi, switchLang } from '../../redux/actions';
import LangWrapper from '../../components/LangWrapper';
import { fetchMenu, fetchDate } from '../../redux/actions';
import slug from 'slug'

import SubNav from '../../components/SubNav';

import './Header.css';
import './MobileNav.css';

class Header extends Component {
  constructor(props){
    super(props)
    this.state = {
      navigationOpen: false,
      menuOpen: false,
    }
  }

  componentDidMount() {
    const locale = this.props.intl.locale;

    this.props.fetchDate();

    if (!this.props.navi) {
      this.props.fetchNavi(locale);
    }

    if (!this.props.menus.length) {
      this.props.fetchMenu(this.props.date, locale);
    }

    let lastScrollTop = 0

    window.addEventListener('scroll', function() {
      let nav = document.querySelector('header.sticky-header')
      let st = window.pageYOffset || document.documentElement.scrollTop

      if (st > lastScrollTop){
        // downscroll
        if(window.pageYOffset > nav.offsetHeight) {
          nav.classList.remove('full')
          nav.classList.add('hide')
          if(window.pageYOffset > 500) {
            nav.classList.remove('hide')
            nav.classList.add('sticky')
          }
        }
      } else {
        // upscroll

        if(window.pageYOffset > 500) {
          nav.classList.add('full')
        }
        else {
          nav.classList.add('hide')
          if(window.pageYOffset < 300) {
            nav.classList.remove('sticky')
            nav.classList.remove('full')
            nav.classList.remove('hide')
          }
        }
      }
      lastScrollTop = st;
    })
  }

  componentDidUpdate() {
    window.scroll(0, 0);
  }

  handleNavToggle() {
    if(this.state.navigationOpen) {
      this.setState({
        navigationOpen: false
      })
    }
    else {
      // if(window.innerWidth <= 767) {
        this.setState({
          navigationOpen: true
        })
      // }
    }
  }

  handleMenu() {
    if(this.state.menuOpen) {
      this.setState({
        menuOpen: false
      })
    }
    else {
      this.setState({
        menuOpen: true
      })
    }
  }

  onSwitchLang() {
    this.props.switchLang();
    window.location.reload();
  }

  render() {
    const isItemValid = (item, time) => {
      return (!item.fields.validFrom || new Date(time) >= new Date(item.fields.validFrom))
        && (!item.fields.validUntil || new Date(time) < new Date(item.fields.validUntil));
    }
    const {naviItems, menus, match} = {...this.props};
    const currentSlug = match.params.slug;
    const date = this.props.date;

    let childrenBool;

    if(naviItems) {
      naviItems.forEach((item) => {
        const mainPage = item.mainPage || (item.childPages ? item.childPages[0] : null);
        let isCurrent = currentSlug === mainPage.fields.slug;
        if(item.childPages) {
          item.childPages.map(child => isCurrent = isCurrent || currentSlug === child.fields.slug);

          if (isCurrent) {
            childrenBool = true;
          }
        }
      })
    }

    let children;

    return (
      <header className={"sticky-header"+(childrenBool||currentSlug==='menu'?' subnav':'')}>
        <NavLink to="/"><span className="logo">W Restaurants</span></NavLink>
        <nav>
          { naviItems &&
            naviItems.map((item, i) => {
              const mainPage = item.mainPage || (item.childPages ? item.childPages[0] : null);
              let isCurrent = currentSlug === mainPage.fields.slug;
              if(item.childPages) {
                item.childPages.map(child => isCurrent = isCurrent || currentSlug === child.fields.slug);

                if (isCurrent) {
                  children = item.childPages;
                }
              }

              return (
                <NavLink key={`navilink_${i}`} to={`/${mainPage.fields.slug}`} activeClassName="active" className={isCurrent?'active':null}>
                  {item.label}
                </NavLink>
              );
            })
          }
          <NavLink to="/contact" activeClassName="active">{this.props.intl.messages["header.contactUs"]}</NavLink>

          { children &&
            <SubNav
              onNav={() => this.handleNavToggle()}
              items={children.map(item => ({
                link: `/${item.fields.slug}`,
                hidden: false,
                title: item.fields.title,
              })
            )} />
          }

          { this.props.location.pathname.indexOf('menu')>=0 &&
            <SubNav
              currentPath={this.props.location.pathname}
              onNav={() => this.handleNavToggle()}
              items={menus.map(item => {
                let link = `/menu/${slug(item.fields.title.toLowerCase())}`;
                let parent = link;

                if(item.fields.children) {
                  const children = item.fields.children.filter(category => isItemValid(category, date));

                  if(children) {
                    link = `${link}/${slug(children[0].fields.title.toLowerCase())}`;
                  }
                }
                return(
                {
                parent: parent,
                link: link,
                hidden: !item.fields.showInNavigation,
                title: item.fields.title,
              })}
            )} />
          }
        </nav>

        <Link to="/reservation" className="reservation btn_reservation" onClick={this.handleNavToggle.bind(this)}>{this.props.intl.messages["general.bookTable"]}</Link>
        <Link to="/lahjakortti" className="reservation gifts" activeClassName="active" onClick={this.handleNavToggle.bind(this)}>{this.props.intl.messages["general.giftBtn"]}</Link>

        <LangWrapper onSwitch={() => this.onSwitchLang()} />

        <span className="nav-toggle" onClick={this.handleNavToggle.bind(this)}><span /><span /><span /></span>

        <nav className={'mobile-nav '+(this.state.navigationOpen ? 'open' : '')}>
          <span className="close" onClick={this.handleNavToggle.bind(this)} />

          <LangWrapper onSwitch={() => this.onSwitchLang()} />

          <NavLink to="/" activeClassName="active" onClick={this.handleNavToggle.bind(this)}>{this.props.intl.messages["header.home"]}</NavLink>

          { naviItems &&
            naviItems.map((item, i) => {
              const mainPage = item.mainPage || (item.childPages ? item.childPages[0] : null);
              let isCurrent = currentSlug === mainPage.fields.slug;
              let children;
              if(item.childPages) {
                item.childPages.map(child => isCurrent = isCurrent || currentSlug === child.fields.slug);

                if (isCurrent) {
                  children = item.childPages;
                }
              }

              return (
                <span key={`navilink_${i}`}>
                  <NavLink to={`/${mainPage.fields.slug}`} activeClassName="active" onClick={this.handleNavToggle.bind(this)}>
                    {item.label}
                  </NavLink>
                  { children &&
                    <SubNav
                      onNav={() => this.handleNavToggle()}
                      items={children.map(item => ({
                        link: `/${item.fields.slug}`,
                        hidden: false,
                        title: item.fields.title,
                      })
                    )} />
                  }
                  {(mainPage.fields.slug === 'menu' && currentSlug === 'menu') &&
                    <SubNav
                      onNav={() => this.handleNavToggle()}
                      items={menus.map(item => {
                        let link = `/menu/${slug(item.fields.title.toLowerCase())}`;

                        if(item.fields.children) {
                          const children = item.fields.children.filter(category => isItemValid(category, date));

                          if(children) {
                            link = `${link}/${slug(children[0].fields.title.toLowerCase())}`;
                          }
                        }
                        return(
                        {
                        link: link,
                        hidden: !item.fields.showInNavigation,
                        title: item.fields.title,
                      })}
                    )} />
                  }
                </span>
              );
            })
          }
          <NavLink to="/contact" activeClassName="active" onClick={this.handleNavToggle.bind(this)}>{this.props.intl.messages["header.contactUs"]}</NavLink>

          <Link to="/reservation" className="reservation" onClick={this.handleNavToggle.bind(this)}>{this.props.intl.messages["general.bookTable"]}</Link><br />
          <Link to="/lahjakortti" className="reservation gifts" activeClassName="active" onClick={this.handleNavToggle.bind(this)}>{this.props.intl.messages["general.giftBtn"]}</Link>
        </nav>
      </header>
    );
  }
}

Header.propTypes = {
  intl: intlShape.isRequired,
}

const mapStateToProps = state => ({
  naviItems: state.navi,
  menus: state.menus,
  date: state.date,
});

const mapDispatchToProps = {
  fetchNavi,
  fetchMenu,
  fetchDate,
  switchLang
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(Header)));



// WEBPACK FOOTER //
// ./src/containers/Header/Header.js